import React from 'react';

import {fileInfoFromName} from '../fileInfoFromName';
import {PatchDelta} from '../PatchDelta';
import {useParsePatch} from '../PatchViewer/useParsePatch';
import {usePatchStats} from '../PatchViewer/usePatchStats';
import type {FileBrowserFile, UseFileBrowserLoadFile} from '../types';
import {useFile} from '../useFile';

type FileRowPatchDeltaProps = {
  file: FileBrowserFile;
  useLoadFile: UseFileBrowserLoadFile;
};

export function FileRowPatchDelta({file, useLoadFile}: FileRowPatchDeltaProps) {
  const fileInfo = fileInfoFromName(file.name);
  const {data: fileBody} = useFile(useLoadFile, file, {
    skip: fileInfo.type !== 'patch',
  });
  const [patch] = useParsePatch(fileBody);
  const patchStats = usePatchStats(patch);

  if (fileInfo.type !== 'patch' || !patchStats) {
    return null;
  }

  return (
    <div className="flex flex-row gap-2">
      <PatchDelta adds={patchStats.adds} dels={patchStats.dels} size="sm" />
    </div>
  );
}
